import React from "react";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";
// material
import { Box } from "@mui/material";
import { BoxProps } from "@mui/system";

interface Props extends BoxProps {
  children: React.ReactNode;
  title?: string;
}
const Page = forwardRef(({ children, title = "", ...other }: Props, ref) => (
  <Box ref={ref} {...other}>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
  </Box>
));

export default Page;
